module Client.Shared

open Shared

type User = {
    Username: string
    Expires: int64
    LinkedCustomersCount: int
}

type TempLoggedInModel =
  { route : Pages.Page
    user: User
    reCaptchaSiteKey : string }

type LoggedInModel =
  { route : Pages.Page
    user: User
    reCaptchaSiteKey : string }

type LoggedOutModel =
  { route : Pages.Page
    reCaptchaSiteKey : string }

type Model =
  | LoggedIn of LoggedInModel
  | LoggedOut of LoggedOutModel
  | TempLoggedIn of TempLoggedInModel
  member this.route =
    match this with
    | LoggedIn loggedInModel -> loggedInModel.route
    | LoggedOut loggedOutModel -> loggedOutModel.route
    | TempLoggedIn tempLoggedInModel -> tempLoggedInModel.route
  member this.reCaptchaSiteKey =
    match this with
    | LoggedIn loggedInModel -> loggedInModel.reCaptchaSiteKey
    | LoggedOut loggedOutModel -> loggedOutModel.reCaptchaSiteKey
    | TempLoggedIn tempLoggedInModel -> tempLoggedInModel.reCaptchaSiteKey
  member this.user =
    match this with
    | LoggedIn loggedInModel -> Some loggedInModel.user
    | LoggedOut loggedOutModel -> None
    | TempLoggedIn tempLoggedInModel -> Some tempLoggedInModel.user

  member this.setRoute newRoute =
    match this with
    | LoggedIn loggedInModel -> LoggedIn { loggedInModel with route = newRoute }
    | LoggedOut loggedOutModel -> LoggedOut { loggedOutModel with route = newRoute }
    | TempLoggedIn tempLoggedInModel -> TempLoggedIn { tempLoggedInModel with route = newRoute }

type Msg =
  | Failed of exn
  | GoTo of Pages.Page
  | DoNothing
  | LoginSuccess of LoginResponse
  | LoginRefreshSuccess of LoginRefreshResponse
  | Logout
  | CheckTokenValidity
  | RefreshToken
  | PasswordChanged